import { render, staticRenderFns } from "./new-event.vue?vue&type=template&id=5dce9989&"
import script from "./new-event.vue?vue&type=script&lang=js&"
export * from "./new-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports